import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserActions from "../../../User/reducer";

const useFetchVisaCodesList = ({
  businessAccountId,
  search,
  PAGE_SIZE,
  enabled,
  isAdmin = false,
}) => {
  const dispatch = useDispatch();
  const {
    visaCodesByEnrollment,
    visaCodesByEnrollmentFetching,
    moreVisaCodesByEnrollmentFetching,
  } = useSelector((state) => state.user);
  const [page, setPage] = useState(1);
  const firstSearchEffect = useRef(true);

  const fetchCodesReq = (params) => {
    dispatch(UserActions.getVisaCodesByEnrollmentRequest(params));
  };

  const fetchMoreCodesReq = (params) => {
    dispatch(UserActions.getMoreVisaCodesByEnrollmentRequest(params));
  };

  const fetchCodes = (nextPage = 1) => {
    if (!enabled) return;

    const params = {
      business_account_id: businessAccountId,
      page: nextPage,
      page_size: PAGE_SIZE,
      search: search || undefined,
      isAdmin,
    };

    if (nextPage === 1) {
      fetchCodesReq(params);
      setPage(1);
      return;
    }

    fetchMoreCodesReq(params);
    setPage(nextPage);
  };

  const fetchMore = () => {
    if (!visaCodesByEnrollment?.next || moreVisaCodesByEnrollmentFetching) return;
    fetchCodes(page + 1);
  };

  useEffect(() => {
    if (!enabled) return;
    fetchCodes(1);
  }, [enabled]);

  useEffect(() => {
    if (firstSearchEffect.current) {
      firstSearchEffect.current = false;
      return;
    }

    if (!enabled) return;

    const timeout = setTimeout(() => {
      fetchCodes(1);
    }, 300);

    return () => clearTimeout(timeout);
  }, [search]);

  return {
    codes: visaCodesByEnrollment?.results || [],
    loading: visaCodesByEnrollmentFetching,
    moreLoading: moreVisaCodesByEnrollmentFetching,
    hasMore: Boolean(visaCodesByEnrollment?.next),
    fetchMore,
  };
};

export default useFetchVisaCodesList;


// https://api.develop-5.chargeback.io/api/user/enrollments/c5f41458-f61b-4c5a-8f0b-9a369e3e0f2f/billing-descriptors/?status=active,pending,pending_unenroll,in_re_enrollment,in_progress,enrolled_elsewhere,generic_descriptor,banned_descriptor,invalid_descriptor,unenrolled,verification_needed,invalid_arns,needs_assistance&page=1&page_size=20
// https://api.develop-5.chargeback.io/api/user/enrollments/bc937ebe-9b29-4c52-a672-4daee6e1c267/billing-descriptors/?status=active,pending,pending_unenroll,in_re_enrollment,in_progress,enrolled_elsewhere,generic_descriptor,banned_descriptor,invalid_descriptor,unenrolled,verification_needed,invalid_arns,needs_assistance&page=1&page_size=20
